import { authClient, API } from "./index";

/**
 * Obtener estadísticas de asociados
 */
export const getAssociatesStats = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  return authClient().get(
    `${API}/dashboard/associates${queryParams.toString() ? `?${queryParams.toString()}` : ""}`
  );
};

/**
 * Obtener estadísticas de pagos
 */
export const getPaymentsStats = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  return authClient().get(
    `${API}/dashboard/payments${queryParams.toString() ? `?${queryParams.toString()}` : ""}`
  );
};

/**
 * Obtener estadísticas de cursos
 */
export const getCoursesStats = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  return authClient().get(
    `${API}/dashboard/courses${queryParams.toString() ? `?${queryParams.toString()}` : ""}`
  );
};

/**
 * Obtener estadísticas de leads
 */
export const getLeadsStats = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  return authClient().get(
    `${API}/dashboard/leads${queryParams.toString() ? `?${queryParams.toString()}` : ""}`
  );
};

